export const rem = (px: number | string) => (!isNaN(Number(px)) ? `${Number(px) / 16}rem` : null);
